import React, { useState } from "react";
import { FaRobot, FaTimes } from "react-icons/fa";

const FloatingBot = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating Icon */}
<button
  onClick={() => setOpen(!open)}
  className="fixed bottom-24 right-4 z-40 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-xl transition"
  title="AI Assistant"
>
  {open ? <FaTimes size={20} /> : <FaRobot size={20} />}
</button>


      {/* Bot Panel (basic placeholder) */}
      {open && (
        <div className="fixed bottom-20 right-6 bg-white rounded-lg shadow-xl w-72 p-4 z-50">
          <h4 className="font-bold text-blue-700 mb-2">AI Assistant</h4>
          <p className="text-sm text-gray-700 mb-2">👋 Hi! How can I Assist you today?</p>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>💡 Ask about study abroad</li>
            <li>📋 How to apply for a visa</li>
            <li>🎯 What documents are required?</li>
          </ul>
        </div>
      )}
    </>
  );
};

export default FloatingBot;
